import { PreferencesContext } from "../../contexts/PreferencesContext"; // Library Imports
import React, { Component } from "react";
import TableEmptyState from '../ReusableComponents/TableEmptyState';
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { BsFillEyeFill } from "react-icons/bs";
import { FaStar, FaUserCircle } from "react-icons/fa";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Modal, Button, Tooltip, OverlayTrigger } from "react-bootstrap";

// Utils Imports
import { logout } from "../../actions/AppActions";
import formatDate from "../../Auxiliar/formatDate";
import { get, post } from "../../Services/api";
import Search from "../ReusableComponents/Search";
import { Pagination } from '@material-ui/lab';
import Attention from "../ReusableComponents/Attention";
import DefaultButton from "../ReusableComponents/DefaultButton";
import { MdSaveAlt } from "react-icons/md";
import { RiSendPlaneLine } from "react-icons/ri";
import SweetAlert from "react-bootstrap-sweetalert";
import StatusBadge, { getApprovalStatus } from "../ReusableComponents/StatusBadge";

const SuccessModal = ({ show, handleClose, handleTableUpdate, t }) =>
<SweetAlert
  success
  title={"Sucesso"}
  onConfirm={() => {
    handleClose();
    // this.delete_banner(this.state.banner_to_delete);
  }}
  onCancel={() => {
    handleClose();

  }}
  show={show}
  confirmBtnText='Ok'
  confirmBtnBsStyle="success">{t("ui_questao_avaliada_com_sucesso_55663755")}



</SweetAlert>;


class AvaliarQuestoes extends Component {static contextType = PreferencesContext;
  constructor(props) {
    super(props);
    this.state = {
      demandas: [],
      questoes: [],
      loading: true,
      redirect: false,
      categoria: null,
      demanda: null,
      pagination: null,
      isModalOpen: false,
      novoComentario: "",
      status: "",
      comentarios: [],
      isCommentsLoading: false,
      showSuccessModal: false,
      questao: {},
      isModalLoading: false,
      search: '',
      statusMsg: '',
      loadingStatus: false,
      loadingAddComent: false,
      statusFilter: 'all'
    };
  }

  componentDidMount() {
    this.fetchQuestoes();
  }

  fetchQuestoes = async (page = 1, search = '') => {
    try {
      const { token } = this.props;
      const params = new URLSearchParams({
        search: search || '',
        page
      });
      if (this.state.statusFilter && this.state.statusFilter !== 'all') {
        params.append('status', this.state.statusFilter);
      }
      const resp = await get(
        `api/faculdade/get_all_questoes?${params.toString()}`,
        token
      );
      const questoesWithDemanda = resp.questoes;

      this.setState((prevState) => ({
        questoes: questoesWithDemanda,
        pagination: resp.pagination,
        loading: false
      }));
    } catch (error) {
      this.setState({ redirect: true });
    }
  };



  editStatusQuestao = async (status, questao_) => {
    const { token } = this.props;
    const id = questao_.id;
    this.setState({ loadingStatus: true, statusMsg: '' });


    let data = { edited: false };
    if (questao_.edited == true) {
      data.edited = true;
    }
    console.log(questao_, status);
    document.getElementById('text_enunciado').innerHTML = questao_.name;
    data.enunciado = questao_.name;
    data.content_enunciado = document.getElementById('text_enunciado').textContent;
    data.categoria_id = questao_.categoria.id;

    data.escolaridade = questao_.escolaridade;
    data.dificuldade = questao_.dificuldade;
    data.type_questao = questao_.type_questao;


    data.palavras_chaves = questao_.palavras_chaves;

    if (questao_.type_questao == 'simples') {
      data.alternativa_a = questao_.alternativas[0].name;
      data.numero_alternativa = questao_.alternativas.length;
      if (data.numero_alternativa >= 2) data.alternativa_b = questao_.alternativas[1].name;
      if (data.numero_alternativa >= 3) data.alternativa_c = questao_.alternativas[2].name;
      if (data.numero_alternativa >= 4) data.alternativa_d = questao_.alternativas[3].name;
      if (data.numero_alternativa >= 5) data.alternativa_e = questao_.alternativas[4].name;

      data.correta = questao_.correta;
    } else
    if (questao_.type_questao == 'conjunto') {
      let questoes = [...questao_.questoes];
      console.log(questoes);
      questoes = questoes.map((item, id) => {
        item = { ...item };
        item.numero_alternativa = item.alternativas.length;
        item.alternativa_a = item.alternativas[0].name;
        if (item.numero_alternativa >= 2) item.alternativa_b = item.alternativas[1].name;
        if (item.numero_alternativa >= 3) item.alternativa_c = item.alternativas[2].name;
        if (item.numero_alternativa >= 4) item.alternativa_d = item.alternativas[3].name;
        if (item.numero_alternativa >= 5) item.alternativa_e = item.alternativas[4].name;



        delete item.alternativas;
        item.categoria_id = item.categoria.id;
        delete item.categoria;
        return item;
      });
      data.questoes = questoes;
    } else
    {



      //dissertiva nao precisa de mais nada, apenas enunciado
    }data.questao_id = id;console.log({ status, ...data });post(`api/faculdade/update_status_questao/${id}`, { status, ...data }, token).then((resp) => {
      if (resp.message == "Unauthenticated.") {
        localStorage.removeItem('token');localStorage.removeItem('user');
        dispatchEvent(logout());
        this.props.logout();
        return;
      }
      if (resp.status == false) {
        this.setState({ statusMsg: resp.message, loadingStatus: false });
        document.getElementById("avaliacao_header").scrollIntoView();

      } else
      if (resp.errors != null || resp.error != null) {
        let errors = Object.values(resp.errors);
        let erro = '';
        for (let i = 0; i < errors.length; i++) {
          if (i != errors.length - 1)
          erro += errors[i] + '\n';else

          erro += errors[i];
        }
        this.setState({ statusMsg: erro, loadingStatus: false });
        document.getElementById("avaliacao_header").scrollIntoView();
      } else
      {
        let questoes = this.state.questoes.map((item) => {
          if (item.id == questao_.id) {
            item.statusAprovacao = status;
            if (questao_.id == item.id) {
              questao_ = { ...item };
            }
          }
          return item;
        });
        this.setState({ statusMsg: '', loadingStatus: false, showSuccessModal: true, questoes, questao: questao_ });
        this.closeModal();

      }

    }).catch((e) => {
      console.log(e);
      this.setState({ loadingStatus: false });

    });
  };

  handleAddComentario = async (questaoId) => {
    const { token, user } = this.props;
    const { novoComentario } = this.state;
    this.setState({ loadingAddComent: true, statusMsg: '' });
    try {
      let resp = await post(
        "api/faculdade/store_comentario",
        { questao_id: questaoId, comentario: novoComentario },
        token
      );
      console.log(resp);
      if (resp.message == "Unauthenticated.") {
        localStorage.removeItem('token');localStorage.removeItem('user');
        this.props.logout();
        return;
      }
      if (resp.status == false) {
        this.setState({ statusMsg: resp.message, loadingAddComent: false });
        document.getElementById("avaliacao_header").scrollIntoView();

      } else
      if (resp.errors != null || resp.error != null) {
        let errors = Object.values(resp.errors);
        let erro = '';
        for (let i = 0; i < errors.length; i++) {
          if (i != errors.length - 1)
          erro += errors[i] + '\n';else

          erro += errors[i];
        }
        this.setState({ statusMsg: erro, loadingAddComent: false });
        document.getElementById("avaliacao_header").scrollIntoView();
      } else
      {
        let questao = this.state.questao;
        let questoes = this.state.questoes.map((item) => {
          if (item.id == questaoId) {
            item.comentarios = [
            ...item.comentarios,
            {
              comentario: novoComentario,
              user_name: user.name,
              created_at: new Date().toISOString()
            }];

            if (questao.id == item.id) {
              questao = { ...item };
            }
          }
          return item;
        });
        this.setState((prevState) => ({
          questoes,
          questao,
          novoComentario: "",
          loadingAddComent: false
        }));
      }

    } catch (error) {}
  };

  openModal = (questao) => {
    console.log(questao);
    this.setState({ isModalOpen: true, questao: questao, status: questao.statusAprovacao ?? '', isModalLoading: false });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  handleNovoComentarioChange = (event) => {
    this.setState({ novoComentario: event.target.value });
  };

  handleStatusChange = (event) => {
    this.setState({ status: event.target.value });
  };

  handleSubmitStatus = () => {
    this.editStatusQuestao(this.state.status, this.state.questao);
  };

  handleSubmitComentario = () => {
    this.handleAddComentario(this.state.questao.id);
  };
  handleTableUpdate = () => {
  };

  render() {
    const {
      redirect,
      loading,
      isModalOpen,
      isCommentsLoading,
      questao,
      novoComentario,
      status,
      showSuccessModal,
      isModalLoading,
      statusMsg,
      loadingAddComent,
      loadingStatus,
      statusFilter
    } = this.state;

    const questoesFiltradas = this.state.questoes;

    if (redirect) {
      return <Redirect to="/error" />;
    }

    return (
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body" id="card">
              <h4 className="mt-0 header-title">{this.context.t("legacy_lista_de_questoes_para_avaliacao")}</h4>
              <p>{`
                ${this.context.t("legacy_aqui_sao_listados_todas_as_questoes_pendentes_do_seu_sistema")}
              `}</p>
              <div className="row">
                <div className="flex jcsb flex-wrap mb-2" style={{ gap: '12px' }}>

                  <Search placeholder={this.context.t("placeholder_search_question")} ValueChange={(value) => {
                    clearTimeout(this.pesquisarTimeout);
                    this.pesquisarTimeout = setTimeout(() => {
                      let page = { ...(this.state.pagination || {}) };
                      page.current_page = 1;
                      this.setState({ pagination: page, search: value, loading: true });
                      this.fetchQuestoes(1, value);
                    }, 2000);
                  }} />






                  <label className="table-filter-control">
                    <span>{this.context.t("label_auditor_status")}</span>
                    <select
                      value={statusFilter}
                      onChange={(e) => {
                        const page = { ...(this.state.pagination || {}), current_page: 1 };
                        this.setState({ statusFilter: e.target.value, pagination: page, loading: true }, () => {
                          this.fetchQuestoes(1, this.state.search);
                        });
                      }}
                    >
                      <option value="all">{this.context.t("option_all_feminine")}</option>
                      <option value="pendente">{this.context.t("summary_pending_plural")}</option>
                      <option value="aprovado">{this.context.t("status_approved_plural")}</option>
                      <option value="recusado">{this.context.t("status_rejected_plural")}</option>
                    </select>
                  </label>

                </div>

                {loading ?
                <div className="d-flex justify-content-center">
                    <CircularProgress />
                  </div> :

                <div>
                    <div className="table-modern-card">
                      <div className="table-modern-scroll mb-0">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>{this.context.t("label_statement")}</th>
                              <th>{this.context.t("ui_tipo_de_questao_d2c9716b")}</th>
                              <th>{this.context.t("label_subject")}</th>
                              <th>{this.context.t("legacy_nome_do_elaborador")}</th>
                              <th>{this.context.t("legacy_identificador_da_demanda")}</th>
                              <th>{this.context.t("label_auditor_status")}</th>
                              <th>{this.context.t("legacy_data_da_ultima_atualizacao")}</th>
                              <th>{this.context.t("label_actions")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {questoesFiltradas.length == 0 ?
                            <tr className="table-empty-row">
                              <td colSpan="8">
                                <TableEmptyState title={this.context.t("empty_no_questions_found_dot")} icon="❓" />
                              </td>
                            </tr> :
                            questoesFiltradas.map((questao, index) =>
                          <tr key={index}>
                                  <td>{questao.text_questao}</td>
                                  {questao.type_questao == "simples" &&
                            <td>{this.context.t("legacy_multipla_escolha")}</td>
                            }
                                    {questao.type_questao == "conjunto" && <td>Conjunto de {questao.questoes.length}{this.context.t("questions")}</td>}

                                      {questao.type_questao == "dissertativa" &&
                            <td>Dissertativa</td>
                            }
                                  <td>{questao.categoria.name}</td>
                                  <td>{questao.user.name}</td>

                                  <td>{questao.demanda.id}</td>
                                  <td><StatusBadge {...getApprovalStatus(questao.statusAprovacao)} /></td>
                                  <td>{formatDate(questao.updated_at)}</td>
                                  <td>
                                    <div className="actions-group">
                                    <Link
                                to={`/avaliar-questoes/show/${questao.id}`}
                                onClick={(e) => e.stopPropagation()}>

                                      <span
                                  className="inline-flex align-center jcc bg-warning icon"
                                  style={{
                                    width: "2em",
                                    height: "2em",
                                    borderRadius: "7px",
                                    marginRight: "2px"
                                  }}
                                  title={this.context.t("legacy_gerenciar")}>

                                        <BsFillEyeFill
                                    size={17}
                                    color="white" />

                                      </span>
                                    </Link>

                                    <span
                                onClick={() => this.openModal(questao)}
                                style={{ cursor: "pointer" }}>

                                      <span
                                  className="inline-flex align-center jcc bg-info icon"
                                  style={{
                                    width: "2em",
                                    height: "2em",
                                    borderRadius: "7px",
                                    marginRight: "2px"
                                  }}
                                  data-toggle="tooltip"
                                  title={this.context.t("legacy_avaliar_questao")}>

                                        <FaStar color="white" size={17} />
                                      </span>
                                    </span>

                                    </div>
                                    </td>
                                </tr>
                          )
                          }
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {questoesFiltradas.length > 0 && <Pagination
                    className={this.state.pagination.last_page == 1 ? "hide" : ""}
                    style={{ display: "flex", justifyContent: "flex-end" }}
                    count={this.state.pagination.last_page}
                    value={this.state.pagination.current_page}
                    onChange={(_, value) => {
                      console.log(_, value);
                      let page = { ...this.state.pagination };
                      page.current_page = value;
                      this.setState({ pagination: page, loading: true });
                      this.fetchQuestoes(value, this.state.search);
                    }} />}

                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div hidden id="text_enunciado">

        </div>
        <Modal show={isModalOpen} onHide={this.closeModal} centered>
          <Modal.Header closeButton>
            <Modal.Title className="fs-5 fw-bold">{this.context.t("legacy_avaliar_questao")}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            {isModalLoading ?
            <div className="d-flex justify-content-center">
                <CircularProgress />
              </div> :

            <>
                <div className="mb-4" id="avaliacao_header">
                {statusMsg != '' && <div style={{ display: 'flex', marginBottom: 15, width: '100%' }}>
                <div className="badge badge-danger error-message-badge error-message-badge-dismissible w-100" role="alert">
                  <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => this.setState({ statusMsg: '' })}></button>


                  <p style={{ marginBottom: 0, whiteSpace: 'pre' }}>{statusMsg}</p>

                </div>
                <br />

              </div>}
                  <h6 className="fw-semibold text-dark mb-3">{this.context.t("legacy_comentarios")}</h6>
                  {isCommentsLoading ?
                <p className="text-muted text-center">{this.context.t("ui_carregando_comentarios_c260c035")}

                </p> :

                <ul className="list-unstyled">
                      {questao?.comentarios?.length == 0 && <li>{this.context.t("legacy_nenhum_comentario_adicionado")}</li>}
                      {questao?.comentarios?.map((comentario, index) =>
                  <li
                    key={index}
                    className="d-flex align-items-center mb-3"
                    style={{ cursor: "pointer" }}>

                         <div className="me-3">
                           <FaUserCircle className="fs-4 text-muted" />
                         </div>
                         <div className="flex-grow-1">
                           <OverlayTrigger
                        placement="top"
                        overlay={
                        <Tooltip id={`tooltip-${index}`}>
                                 Criado em: {formatDate(comentario.created_at)}
                               </Tooltip>
                        }>

                             <div className="d-flex justify-content-between align-items-center">
                               <strong className="text-muted me-2">
                                 {comentario.user_name}
                               </strong>
                               <small className="text-muted">
                                 {formatDate(comentario.created_at)}
                               </small>
                             </div>
                           </OverlayTrigger>
                           <p className="mb-0 text-dark">{comentario.comentario}</p>
                         </div>
                       </li>
                  )}
                    </ul>
                }
                </div>

                <div className="mb-4">
                  <h6 className="fw-semibold text-dark mb-3">{`
                    ${this.context.t("legacy_adicionar_comentario")} `}<Attention />
                  </h6>
                  <textarea
                  className="form-control mb-2"
                  value={novoComentario}
                  onChange={this.handleNovoComentarioChange}
                  placeholder={this.context.t("ui_escreva_seu_comentario_aqui_c2486f14")} />

                  <div className="d-flex justify-content-end mt-2">
                  {loadingAddComent == false ? <DefaultButton
                    bg="info"
                    icon={<MdSaveAlt />}
                    text={this.context.t("legacy_salvar_comentario")}
                    onClick={() => this.handleSubmitComentario()}>


                  </DefaultButton> : <CircularProgress />}
                  </div>
                </div>

                <div className="mb-4">
                  <h6 className="fw-semibold text-dark mb-3">Avaliar</h6>
                  {["aprovado", "recusado"].map((option) =>
                <div
                  key={option}
                  className="d-flex align-items-center mb-2">

                      <input
                    type="radio"
                    id={option}
                    className="form-check-input me-2"
                    value={option}
                    checked={status === option}
                    onChange={this.handleStatusChange} />

                      <label htmlFor={option} className="form-check-label">
                        {option === "aprovado" ? "Aprovar" : "Desaprovar"}
                      </label>
                    </div>
                )}
                </div>

                <div className="d-flex justify-content-end">
                  {loadingStatus == false ? <DefaultButton
                  bg="confirm"
                  text={this.context.t("ui_enviar_avaliacao_629e5d59")}

                  icon={<RiSendPlaneLine />}

                  onClick={() => this.handleSubmitStatus()}>

                </DefaultButton> : <CircularProgress />}
                </div>
              </>
            }
          </Modal.Body>
        </Modal>

        <SuccessModal
          show={showSuccessModal}
          handleClose={() => this.setState({ showSuccessModal: false })}
          handleTableUpdate={this.handleTableUpdate}
          t={this.context.t} />

      </div>);

  }
}

const mapStateToProps = (state) => ({
  user: state.AppReducer.user,
  token: state.AppReducer.token
});

export default connect(mapStateToProps, { logout })(AvaliarQuestoes);
